var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 0.666504C1.2 0.666504 0 1.8665 0 3.33317V7.55984C0 8.2665 0.28 8.9465 0.786667 9.45317L5.33333 13.9998L0.773333 18.5598C0.28 19.0665 0 19.7465 0 20.4532V24.6665C0 26.1332 1.2 27.3332 2.66667 27.3332H13.3333C14.8 27.3332 16 26.1332 16 24.6665V20.4532C16 19.7465 15.72 19.0665 15.2267 18.5732L10.6667 13.9998L15.2133 9.4665C15.72 8.95984 16 8.27984 16 7.57317V3.33317C16 1.8665 14.8 0.666504 13.3333 0.666504H2.66667ZM13.3333 19.9998V23.3332C13.3333 24.0665 12.7333 24.6665 12 24.6665H4C3.26667 24.6665 2.66667 24.0665 2.66667 23.3332V19.9998L8 14.6665L13.3333 19.9998ZM8 13.3332L2.66667 7.99984V4.6665C2.66667 3.93317 3.26667 3.33317 4 3.33317H12C12.7333 3.33317 13.3333 3.93317 13.3333 4.6665V7.99984L8 13.3332Z",
    fill: "#C38236"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/SandClock.1e17a04e8b95f5aa2e85f9f7bad3f90f.svg";
export { ForwardRef as ReactComponent };